// extracted by mini-css-extract-plugin
module.exports = {"Icon":"AlertCollection_Icon__d56we"};